import { Modal, useDeviceType } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './DailyrentBookingCalendarSettingsModalContainer.css';
import image from './assets/image.jpg';
import { useDailyrentModal } from '../../utils/dailyrent/useDailyrentModal';

export const DailyrentBookingCalendarSettingsModalContainer = () => {
  const { activeModal, closeModal } = useDailyrentModal();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const isOpen = activeModal === 'booking';

  const onOpenChange = React.useCallback(
    (open: boolean) => {
      if (!open) {
        closeModal();
      }
    },
    [closeModal],
  );

  // Показываем только на десктопе
  if (!isDesktop || !isOpen) {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      onOpenChange={onOpenChange}
      closeButtonProps={{ theme: 'fill_light', title: 'Закрыть', icon: <IconActionClose16 color="current_color" /> }}
      data-testid="DailyrentBookingCalendarSettingsModal"
    >
      <div className={styles['image-container']}>
        <img className={styles['img']} src={image} alt="Наведите камеру, чтобы отсканировать QR-код" />
      </div>
    </Modal>
  );
};
